export const AUTH_ENDPOINT = import.meta.env.VITE_AUTH_ENDPOINT ?? 'http://localhost:3001';

export interface LoginVerifyResponse {
  accessToken: string;
  refreshToken: string;
  refreshExpiresAt: string;
  user: { id: string; email: string; displayName: string | null };
  defaultOrgId: string;
  defaultRole: string;
}

export interface RefreshTokenResponse {
  token_type: 'Bearer';
  access_token: string;
  refresh_token: string;
  refresh_expires_at: string;
}

export async function refreshTokenRequest(refreshToken: string): Promise<RefreshTokenResponse> {
  const res = await fetch(`${AUTH_ENDPOINT}/token`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ grant_type: 'refresh_token', refresh_token: refreshToken }),
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`refresh failed: ${res.status} ${txt}`);
  }
  return res.json();
}

export async function startLogin(email: string): Promise<void> {
  const res = await fetch(`${AUTH_ENDPOINT}/login/start`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) throw new Error(`startLogin failed: ${res.status}`);
}

export async function verifyLogin(email: string, code: string): Promise<LoginVerifyResponse> {
  const res = await fetch(`${AUTH_ENDPOINT}/login/verify`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email, code }),
  });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(`verifyLogin failed: ${res.status} ${err}`);
  }
  return res.json();
}
